import { Link } from '@inertiajs/react';
import { route } from '../../utils/route';
import { ConnectionsList } from '../../components/ia-landing/ConnectionsList';
import type { IaConnection } from '../../types/ia-landing';

/** The AI assistants (Claude, ChatGPT…) connected to the account, with a way to disconnect them. */
export function AiAssistantsSection({ connections }: { connections: IaConnection[] }) {
    return (
        <div id="asistentes">
            <div className="mb-4 flex flex-wrap items-start justify-between gap-2">
                <div>
                    <h2 className="text-lg font-semibold text-gray-900">Asistentes de IA</h2>
                    <p className="text-sm text-gray-500">Los asistentes que conectaste a tu cuenta para hacer pedidos hablando.</p>
                </div>
                <Link href={route('ia.landing')} className="text-sm font-semibold text-green-700 hover:underline">
                    {connections.length > 0 ? 'Conectar otro' : 'Conectar Claude o ChatGPT'} →
                </Link>
            </div>
            <ConnectionsList connections={connections} />
        </div>
    );
}
